(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core')) :
	typeof define === 'function' && define.amd ? define('@nguniversal/common/tokens', ['exports', '@angular/core'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.nguniversal = global.nguniversal || {}, global.nguniversal.common = global.nguniversal.common || {}, global.nguniversal.common.tokens = {}), global.ng.core));
}(this, (function (exports, core) { 'use strict';

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ORIGIN_URL = new core.InjectionToken('ORIGIN_URL');
	var REQUEST = new core.InjectionToken('REQUEST');
	var RESPONSE = new core.InjectionToken('RESPONSE');

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */

	/**
	 * Generated bundle index. Do not edit.
	 */

	exports.ɵORIGIN_URL = ORIGIN_URL;
	exports.ɵREQUEST = REQUEST;
	exports.ɵRESPONSE = RESPONSE;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=common-tokens.umd.js.map
